import * as React from 'react'
import { I18n } from 'react-redux-i18n'
import './styles.scss'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'

const _operatorsHeaders = [
  { label: 'dashboard_category', value: 'operator-category', filter: 'asc' },
  { label: 'dashboard_name', value: 'operator-name', filter: null },
  { label: 'dashboard_e-mail', value: 'operator-email', filter: null },
]

const CategoriesList = (props) => {
  const { categories, edit, remove, filterByOperators, orderBy, headers, inRequest } = props

  return (
    <div>
      <div className='header-row'>
        {
          !filterByOperators && categories.length > 0 && headers.map(elem => (
            <div key={elem.value} className={elem.value}>
              <span onClick={() => orderBy(elem)}>{I18n.t(elem.label)}</span>
              {elem.filter && <img src='img/icons/icon-expand.svg' alt='expand' className={`${elem.filter}`} />}
            </div>
          ))
        }
        {
          filterByOperators && categories.length > 0 && _operatorsHeaders.map(elem => (
            <div key={elem.value} className={elem.value}>
              <span onClick={() => orderBy(elem)}>{I18n.t(elem.label)}</span>
              {elem.filter && <img src='img/icons/icon-expand.svg' alt='expand' className={`${elem.filter}`} />}
            </div>
          ))
        }
      </div>
      <div className='categories-list'>
        {inRequest && <div className='spinner'>
          <Nixi1Spinner height='1.5rem' width='1.5rem'/>
        </div>}
        {
          !filterByOperators && categories.length > 0 && categories.map((it) => {
            return (
              <div key={it._id} className='animated fadeIn'>
                <div className='category'>
                  <div style={{ backgroundColor: it.color }} className='all-name-wrapper'>
                    <label className='name' style={{ color: it.color ? 'white' : '#333333' }}>{it.name}</label>
                  </div>
                  <div className='brand-delegation'>
                    <div className='detail'>
                      {
                        it.brands.map(b => (
                          b._id === 'all' || b._id === 'some' ?
                            <span id={b._id} key={b._id}>{I18n.t(`dashboard_${b._id}-plural-female`)}</span>
                            :
                            <span key={b._id}>{b.name}</span>
                        ))
                      }
                    </div>
                    <div className='detail'>
                      {
                        it?.delegations && it.delegations.map(b => (
                          b._id === 'all' || b._id === 'some' ?
                            <span id={b._id} key={b._id}>{I18n.t(`dashboard_${b._id}-plural-female`)}</span>
                            :
                            <span key={b._id}>{b.name}</span>
                        ))
                      }
                    </div>
                  </div>
                  <div className='category-icons'>
                    <img src={getStaticImage('/icons/orange-brand/icon-edit.svg')} alt='Edit' onClick={() => edit(it)} />
                    {it.allowRemove && <img src={getStaticImage('/icons/orange-brand/icon-delete.svg')} alt='Delete' onClick={() => remove(it)} />}
                  </div>
                </div>
              </div>
            )
          })
        }
        {
          filterByOperators && categories.length > 0 && categories.map((it) => {
            return (
              <div key={it._id} className='animated fadeIn'>
                <div className='category'>
                  <div style={{ backgroundColor: it.color }} className='name-wrapper'>
                    <label className='name' style={{ color: it.color ? 'white' : '#333333' }}>{it.name}</label>
                  </div>
                  <div className='brand-delegation'>
                    <div className='detail'>
                      <span>{it.operatorName || 'null'}</span>
                    </div>
                    <div className='detail'>
                      <span>{it.operatorEmail || 'null'}</span>
                    </div>
                  </div>
                  <div className='category-icons'>
                    {it.me && <img src={getStaticImage('/icons/orange-brand/icon-edit.svg')} alt='Edit' onClick={() => edit(it)} />}
                    {it.me && <img src={getStaticImage('/icons/orange-brand/icon-delete.svg')} alt='Delete' onClick={() => remove(it)} />}
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default CategoriesList
